import React from 'react'
import { BadgeContainer, BadgeInnerRound, BadgeRound } from './Badge.style'
import { BadgeVariant } from './types'

interface BadgeProps {
    variant: BadgeVariant
    text: string
    dataTestId?: string
}

const Badge = ({ variant, text, dataTestId }: BadgeProps) => {
    return (
        <BadgeContainer $variant={variant}>
            <BadgeRound $variant={variant}>
                <BadgeInnerRound $variant={variant} />
            </BadgeRound>
            <span data-testid={dataTestId}>{text}</span>
        </BadgeContainer>
    )
}

export default Badge
